/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React, { useEffect, useRef, useState } from 'react';
import {
    string, shape,
} from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import ReactHtmlParser from 'react-html-parser';
import {
    Button,
    ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary,
} from '@material-ui/core';
import {
    Add as AddIcon,
    Remove as RemoveIcon,
} from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: '32px',
        background: theme.palette.white,
        [theme.breakpoints.down('600')]: {
            marginTop: '16px',
            paddingRight: '10px',
        },
    },
    content: {
        '& ul': {
            margin: 0,
        },
        margin: '15px 0px',
    },
    panelRoot: {
        borderBottom: '0.5px solid #555',
        boxShadow: 'none',
        paddingBottom: '16px',
        '&.Mui-expanded': {
            margin: '0px',
        },
        '&:before': {
            display: 'none',
        },
    },
    summaryRoot: {
        '&.Mui-expanded': {
            margin: '0px',
            minHeight: 'auto',
        },
        '& .MuiExpansionPanelSummary-content': {
            display: 'flex',
            justifyContent: 'space-between',
            margin: '0px',
            alignItems: 'center',
        },
    },
    label: {
        color: theme.palette.cms?.black || '#000',
        lineHeight: '24px',
        fontWeight: 600,
        letterSpacing: '2.24px',
        textTransform: 'uppercase',
        fontSize: '16px',
        marginRight: 'auto',
        margin: 0,
    },
    headerWrapper: {
        marginRight: 'auto',
    },
    shortOneLineDescription: {
        display: '-webkit-box',
        boxOrient: 'vertical',
        lineClamp: 3,
        overflow: 'hidden',
        margin: '0px',
    },
    shortDescription: {
        margin: 0,
    },
    icons: {
        display: 'flex',
        alignItems: 'end',
        paddingBottom: '0px',
        '&:hover': {
            background: 'none',
        },
    },
    partNumber: {
        padding: '0px 8px',
    },
}));

const ProductDetailsTab = ({
    productLongDescription, selectedSku, productShortDescription, partNumber,
}) => {
    const descriptionDisplay = productShortDescription || selectedSku.shortDescription || productLongDescription;
    const classes = useStyles();
    const [contentActive, setContentActive] = useState(false);
    const [numberOfLines, setNumberOfLines] = useState(0);
    const textRef = useRef(null);
    const maxLinesToShow = 3;

    useEffect(() => {
        if (textRef.current) {
            const lineHeight = parseInt(getComputedStyle(textRef.current).lineHeight, 10);
            const numberOfLine = textRef.current.clientHeight / lineHeight;
            setNumberOfLines(numberOfLine);
        }
    }, [contentActive]);

    const handleChangePanel = () => setContentActive(!contentActive);
    return (
        <div className={classes.root}>
            <ExpansionPanel classes={{ root: classes.panelRoot }} square expanded>
                <ExpansionPanelSummary classes={{ root: classes.summaryRoot, content: classes.summaryContent }}>
                    <div className={classes.headerWrapper}>
                        <p className={classes.label}>Details</p>
                    </div>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails classes={{ root: classes.detailsRoot }}>
                    <p ref={textRef} className={contentActive ? classes.shortOneLineDescription : classes.shortDescription}>{ReactHtmlParser(descriptionDisplay)}</p>
                    {numberOfLines > maxLinesToShow && (
                        <Button onClick={handleChangePanel} className={classes.icons}>{(contentActive) ? <AddIcon /> : <RemoveIcon />}</Button>
                    )}
                </ExpansionPanelDetails>
                {partNumber && <span className={classes.partNumber}>Product Number: {partNumber}</span>}
            </ExpansionPanel>
        </div>
    );
};

ProductDetailsTab.defaultProps = {
    selectedSku: {},
    partNumber: '',
};

ProductDetailsTab.propTypes = {
    productLongDescription: string.isRequired,
    productShortDescription: string.isRequired,
    partNumber: string,
    selectedSku: shape({
        ageVerifyFlag: string,
        shortDescription: string,
        longDescription: string,
    }),
};

export default ProductDetailsTab;
